export default "https://assets-v2.scaler.com/packs/images/connect-with-rm.a56d58.svg";